module.exports = __webpack_public_path__ + "static/media/search-icon.eb11eb36.svg";